import { conflictsResolved } from '../styles';

const ConflictsResolvedView = () => {
	return (
		<div className={conflictsResolved}>
			<div className="text">
				You have resolved all conflicts. Close this window to continue editing.
			</div>
		</div>
	);
};

export default ConflictsResolvedView;
